module.exports = __webpack_public_path__ + "img/tiktok.c39582ab.svg";